import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/internal/operators';
import {environment} from '../../../environments/environment';
import {Role} from './role.object';

@Injectable()
export class RoleService {

  defaultInclude: any[] = ['API_ACLs', 'GUI_ACLs'];

  constructor(private http: HttpClient) {
  }

  get(ReqParams: HttpParams = null): Observable<Role[]> {
    return this.http
        .get<Role[]>(environment.apiUrl + '/Roles', {params: ReqParams})
        .pipe(
            map(res => <Role[]>res),
            map(res => {
              return res.map(rel => new Role(rel));
            })
        );
  }

  getById(Id: string, ReqParams: HttpParams = null): Observable<Role> {
    return this.http
        .get<Role>(environment.apiUrl + '/Roles/' + Id, {params: ReqParams})
        .pipe(
            map(res => <Role>res),
            map(res => {
              return new Role(res);
            })
        );
  }

  upsert(Relation: Role): Observable<Role> {
    return this.http
        .put(environment.apiUrl + '/Roles', JSON.stringify(Relation))
        .pipe(
            map(res => <Role>res),
            map(res => {
              // Only update available props in relation. (Avoid to add irelevant props)
              for (const prop in res) if (prop in Relation) Relation[prop] = res[prop];
              return new Role(Relation);
            })
        );
  }

  remove(Relation: Role): Observable<{ count: number }> {
    return this.http
        .delete<{ count: number }>(environment.apiUrl + '/Roles/' + Relation.Id);
  }

  count(ReqParams: HttpParams = null): Observable<{ count: number }> {
    return this.http
        .get(environment.apiUrl + '/Roles/count', {params: ReqParams})
        .pipe(
            map(res => <{ count: number }>res)
        );
  }

}
